import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { modifier } from 'ember-modifier';

import styles from './mail-template-renderer.module.css';

interface RenderMailTemplateSignature {
  Args: {
    Positional: [htmlContent: string];
  };
  Element: HTMLIFrameElement;
}

const renderMailTemplate = modifier<RenderMailTemplateSignature>(
  (element, [htmlContent]): void => {
    const { contentWindow } = element;

    if (!contentWindow) {
      return;
    }

    contentWindow.document.open();
    contentWindow.document.write(htmlContent);
    contentWindow.document.close();
  },
);

interface ParityParityManagerMailTemplateRendererSignature {
  Args: {
    htmlContent: string;
    isLoading?: boolean;
  };
}

const ParityParityManagerMailTemplateRenderer = <template>
  {{! template-lint-disable require-iframe-title }}
  {{#if @isLoading}}
    <span class="flex h-full items-center justify-center p-500">
      {{t "general.loading"}}
    </span>
  {{else if @htmlContent}}
    <iframe
      class={{styles.mail-renderer-iframe}}
      {{renderMailTemplate @htmlContent}}
    ></iframe>
  {{else}}
    <span class="flex h-full items-center justify-center p-500">
      {{t "parity_manager.violation_mail_modal.template_error"}}
    </span>
  {{/if}}
</template> satisfies TOC<ParityParityManagerMailTemplateRendererSignature>;

export default ParityParityManagerMailTemplateRenderer;
